import { BuyerSplitSettingState } from './BuyerSplitSettingTypes';

export const SplitSettingsActionTypes = {
  LOADING_SETTINGS: 'loadingSplitSettings',
  LOADED_SETTINGS: 'loadedSplitSettings',
  FAILED_SETTINGS: 'failedLoadingSplitSettings',

  LOAD_BUYER_GROUPS: 'loadBuyerGroups',
  LOADED_BUYER_GROUPS: 'loadedBuyerGroups',
  LOAD_BUYERS: 'loadBuyers',
  LOADED_BUYERS: 'loadedBuyers',
  LOAD_SPLIT_SCENARIOS: 'loadSplitScenarios',
  LOADED_SPLIT_SCENARIOS: 'loadedSplitScenarios',
  LOAD_BUYER_SPLIT_SCENARIOS: 'loadBuyerSplitScenarios',
  LOADED_BUYER_SPLIT_SCENARIOS: 'loadedBuyerSplitScenarios',

  LOAD_SETTINGS_ERROR: 'loadSplitSettingsError',
  VIEW_SPLIT_SCENARIO: 'viewSplitScenario',
  SAVE_BUYER_GROUP_TO_SPLIT_SCENARIO: 'saveBuyerGroupToSplitScenario',
  CREATE_BUYER_GROUP_TO_SPLIT_SCENARIO: 'createBuyerGroupToSplitScenario',
  EDIT_BUYER_GROUP_ON_SPLIT_SCENARIO: 'editBuyerGroupOnSplitScenario',
  DEL_BUYER_GROUP_TO_SPLIT_SCENARIO: 'delBuyerGroupToSplitScenario',
  SPLIT_VALUE_MODIFIED: 'modifiedSplitValue',
  SPLIT_SETTINGS_RESET: 'splitSettingsReset',
  SAVE_SPLIT_SETTINGS: 'saveSplitSettings',
  SAVING_SPLIT_SETTINGS: 'savingSplitSettings',
  FAILED_SPLIT_SETTINGS: 'failedSplitSettings',

  CANCEL_EDITING: 'cancelFormEntry',
};

export const FORM_STATE = {
  OPEN: 'open',
  LOCKED: 'locked',
  DISABLED: 'disabled',
  VALIDATING: 'validating',
  FAILED_SUBMIT: 'failed',
};

export const SplitScenarioSelectorActions = {
  SPLIT_SCENARIO_CHANGE: 'splitScenarioSchanged',
};

export const emptySelection = {
  SplitScenarioBuyerGroupId: 0,
  BuyerGroupId: 0,
  BuyerGroupName: '',
  BuyerId: 0,
  BuyerName: '',
  ScenarioName: '',
  SplitScenarioId: 0,
  SplitValue: 1,
};

export const DEFAULT_STATE: BuyerSplitSettingState = {
  loadStatus: 0,
  splitScenarios: [],
  //buyers: [],
  buyerGroups: [],
  buyerSplitScenarios: [],
  byScenarios: {},
  currentSplitScenario: {
    id: 0,
    form: [],
    orig: [],
    totalSplits: 0,
    formState: FORM_STATE.OPEN,
    formMessages: [],
  },
  editEntry: null,
};
